// @flow
// API
import { authPost, authPut } from '../../api';
// Helpers
import { camelizeKeys } from 'humps';
// Types
import type { VisitorLogUtmPayload } from '../types/VisitorLog';

export async function postVisitorLog(
  payload: VisitorLogUtmPayload,
): Promise<Object> {
  const response = await authPost('/v2/visitor_logs', payload);
  return response.json().then(b => camelizeKeys(b));
}

export async function putVisitorLog(
  id: string,
  payload: VisitorLogUtmPayload,
): Promise<void> {
  await authPut(`/v2/visitor_logs/${id}`, payload);
}
